exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-thumbnail-item {\n  display: flex;\n  margin-bottom: 5px; }\n  .fmcy-thumbnail-item .fmcy-thumbnail-item-inner {\n    cursor: pointer;\n    position: relative;\n    width: 100%; }\n  .fmcy-thumbnail-item .fmcy-thumbnail-item-image-wrapper {\n    position: relative; }\n  .fmcy-thumbnail-item .fmcy-thumbnail-item-inner {\n    border: solid #c4c1c2 2px;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch; }\n    .fmcy-thumbnail-item .fmcy-thumbnail-item-inner .fmcy-thumbnail-item-row {\n      order: 0;\n      flex: 0 1 auto;\n      align-self: auto; }\n    .fmcy-thumbnail-item .fmcy-thumbnail-item-inner .fmcy-thumbnail-item-image {\n      background-size: contain;\n      background-repeat: no-repeat;\n      background-position: center; }\n  .fmcy-thumbnail-item.thumbnail-item-selected .fmcy-thumbnail-item-inner {\n    border: solid #00afb4 2px; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/menu/menu-item-expanded/thumbnail-selector/thumbnail-item/thumbnail-item.scss
 ** module id = 537
 ** module chunks = 1 16 132 167
 **/